const KNOWN_REASONS = new Set([
  'connect_refused',
  'connect_timeout',
  'auth_failed',
  'deadline_exceeded',
  'config_rejected',
  'profile_unavailable',
  'unknown',
  'installation_create_failed',
  'provisioning_aborted',
  'executor_unreachable',
  'iothub_offline',
  'configuration_failed',
  'provisioning_failed',
  'connection_failed',
  'legacy',
]);

/** Translation key for a stored failure reason (`<code>` or `<code>:<detail>`), or null for a
 * code this portal does not know, so the caller can show the raw text instead. */
export function installationFailureReasonKey(reason: string | null | undefined): string | null {
  const code = reason?.split(':')[0] ?? '';
  return KNOWN_REASONS.has(code) ? `devices.installationFailureReason.${code}` : null;
}
